export const COMPANY = {
  name: '핑크페이퍼',
  nameEn: 'PINK PAPER',
  slogan: '서로의 마음을 핑크로 연결하는 곳',
  tel: '1844-2549',
  fax: '02-2179-8119',
  email: 'master@impink.co.kr',
  address: '경기도 남양주시 다산중앙로19번길 21',
  addressDetail: '블루웨일 지식산업센터 1차 F동 307호',
  ceo: '김태연',
  instagram: 'https://www.instagram.com/pinkpaper_official',
  familySite: { name: 'p!nk', url: 'https://impink.co.kr' },
};

export const SERVICES = [
  { title: '공연, 전시, 축제', icon: 'Music', desc: '감동을 전하는 무대를 기획합니다' },
  { title: '국내외 음원 및 음반 유통', icon: 'Disc3', desc: '아티스트의 음악을 세상에 전합니다' },
  { title: '음원 및 뮤직비디오 방송심의', icon: 'MonitorPlay', desc: '방송 심의를 안전하게 대행합니다' },
  { title: '굿즈 개발 및 제작', icon: 'Package', desc: '특별한 굿즈를 만들어 드립니다' },
];

export const PRIVACY_POLICY = `핑크페이퍼(이하 '회사'라 한다)는 개인정보 보호법 제30조에 따라 정보 주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립, 공개합니다.

제1조 (개인정보의 처리목적)
회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

1. 홈페이지 회원 가입 및 관리
회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정 이용 방지, 각종 고지·통지, 고충 처리 등을 목적으로 개인정보를 처리합니다.

2. 재화 또는 서비스 제공
서비스 제공, 콘텐츠 제공, 맞춤서비스 제공, 본인인증 등을 목적으로 개인정보를 처리합니다.

3. 고충 처리
민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리 결과 통보 등의 목적으로 개인정보를 처리합니다.

제9조(개인정보 보호책임자)
▶ 개인정보 보호책임자
성명 : 김태연
직책 : 대표
연락처 : 070-8064-0768, gongd.mail@gmail.com

이 개인정보 처리방침은 2021. 1. 1부터 적용됩니다.`;

export const TERMS_OF_SERVICE = `제1조 (목적)
이 약관은 핑크페이퍼(이하 '회사'라 한다)가 운영하는 p!nk(impink.co.kr, urpink.co.kr, 이하 '서비스'라 한다)의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.

제2조 (용어의 정의)
① '회원'이란 회사와 서비스 이용계약을 체결하고 아이디를 부여받은 자를 말합니다.
② '아이디(ID)'란 회원 식별과 서비스 이용을 위해 회원이 설정하고 회사가 승인한 이메일 주소를 말합니다.
③ '비밀번호'란 회원의 동일성 확인과 개인정보 보호를 위해 회원 스스로가 설정한 문자와 숫자의 조합을 말합니다.

제3조 (약관의 효력 및 변경)
① 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지함으로써 효력이 발생합니다.
② 회사는 합리적인 사유가 발생할 경우 관련 법령에 위배되지 않는 범위 안에서 이 약관을 변경할 수 있으며, 변경된 약관은 공지사항을 통해 공지합니다.

제4조 (서비스의 제공 및 변경)
① 회사는 다음과 같은 서비스를 제공합니다.
  - 음원 및 음반 관련 정보 제공 서비스
  - 플레이리스트, 뮤직비디오, 뮤직트렌드 콘텐츠 서비스
  - 음원 유통 정산 서비스 (권리사 회원 대상)
  - 기타 회사가 정하는 서비스
② 회사는 운영상, 기술상의 필요에 따라 제공하는 서비스를 변경할 수 있습니다.

제5조 (서비스 이용시간)
서비스 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다. 단, 정기 점검 등의 필요로 회사가 정한 날이나 시간은 제외됩니다.

제6조 (회원가입)
① 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.
② 회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.
  - 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우
  - 등록 내용에 허위, 기재누락, 오기가 있는 경우
  - 기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우

제7조 (회원 탈퇴 및 자격 상실)
① 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다.
② 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
  - 가입 신청 시에 허위 내용을 등록한 경우
  - 서비스를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우

제8조 (저작권의 귀속 및 이용제한)
① 회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.
② 이용자는 서비스를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.

제9조 (분쟁해결)
① 회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.
② 회사와 이용자 간에 발생한 분쟁은 전자거래기본법 제28조 및 동 시행령 제15조에 의하여 설치된 전자거래분쟁조정위원회의 조정에 따를 수 있습니다.

제10조 (재판권 및 준거법)
이 약관에서 발생하는 분쟁에 관한 소송은 회사의 본사 소재지를 관할하는 법원을 관할법원으로 하며, 준거법은 대한민국 법으로 합니다.

이 약관은 2021년 1월 1일부터 적용됩니다.`;
